import React, { Component } from 'react';
import Button from "@material-ui/core/Button";
import Localization from "../../config/localization/Localization";
import Link from "@material-ui/core/Link";
import Setup from "../../config/Setup";
import Slide from "@material-ui/core/Slide";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import ChatQuestionTypeEnum from "../../config/constants/ChatQuestionTypeEnum";
import LinkIcon from "@material-ui/icons/TransitEnterexit";
import {getLocalizationLanguageCode} from "../../util/localization";


/**
 * Class for the info page.
 */
class InfoPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            chatMenuItemList: []
        }
    }

    sendIntent = (chatMenuItem) => {
        this.props.sendIntent(chatMenuItem.intentId, ChatQuestionTypeEnum.menuItem,
            chatMenuItem.displayName, null, null, chatMenuItem.id);

        this.props.toggleShowInfoPage()
    };

    render() {

        let chatMenuItemList = [];
        const localizationCode = getLocalizationLanguageCode(this.props.language ? this.props.language.languageCode : null)

        if (this.props.chatConfig && this.props.language) {
            chatMenuItemList = this.props.chatConfig.chatMenuItemList.filter((chatMenuItem) => {
                return chatMenuItem.languageCode === this.props.language.languageCode;
            });
        }

        if (chatMenuItemList.length > 0) {
            chatMenuItemList.sort((a, b) => a.index - b.index);
        }

        return(
            <div id={'info-page-container'}
                 style={{pointerEvents: this.props.showInfoPage ? 'all' : 'none'}}>

                <Slide direction={'down'} timeout={800} in={this.props.showInfoPage}>
                    <div id={'info-page-slide-container'}
                         style={{backgroundColor: this.props.backgroundColor ? this.props.backgroundColor : "white",
                             color: this.props.color ? this.props.color : "black"}} >

                        <div id={'info-page-content-container'} >

                            <div style={{height: '50%', alignItems: 'flex-end'}} className={'info-page-content-box'}  >

                                {chatMenuItemList && chatMenuItemList.length > 0 ?
                                    <div id={'info-page-menu-container'}>
                                        {chatMenuItemList.map((chatMenuItem, index) => (
                                            <MenuItem onClick={() => {this.sendIntent(chatMenuItem);   }} key={index}
                                                      style={{
                                                          font: this.props.chatConfig && this.props.chatConfig.font ? this.props.chatConfig.font : null,
                                                          color: this.props.color ? this.props.color : "black"
                                                      }}>
                                                {chatMenuItem.displayName}
                                            </MenuItem>
                                        ))}
                                    </div> : null}

                            </div>

                            {this.props.gdprLink ?
                                <div style={{height: '10%'}}  className={'info-page-content-box'}>
                                    <Link target={'_blank'} href={this.props.gdprLink} style={this.props.chatConfig && this.props.chatConfig.font ?
                                        {font: this.props.chatConfig.font, color: this.props.color } : null} >
                                        {this.props.language ?
                                            Localization[localizationCode]['infoPage.privacyPolicyLinkText'] : ''
                                        }
                                        <LinkIcon className={'link-gdrp-icon'}/>
                                    </Link>
                                </div> : null}

                            <div style={{height: '10%'}}  className={'info-page-content-box'}>
                                <Button onClick={this.props.toggleShowInfoPage}
                                        variant="contained"
                                        style={{
                                            color: this.props.color ? this.props.color : "black",
                                            backgroundColor: 'transparent'
                                        }}>

                                    {this.props.language ?
                                        Localization[localizationCode]['infoPage.goBackButtonText'] : ''
                                    }
                                </Button>
                            </div>

                            <div style={{height: '20%'}}  className={'info-page-content-box'}>
                                { this.props.chatConfig && this.props.chatConfig.showPoweredBy &&
                                    <a id={'info-page-inchatbot-logo-container'} target="_blank"
                                       href="https://InDialog.ai">
                            <span style={this.props.chatConfig && this.props.chatConfig.font ?
                                {font: this.props.chatConfig.font, color: this.props.color} : null}>

                                Powered by InDialog.ai
                            </span>

                                        <img id={'info-page-inchatbot-logo'} src={Setup.logoUrl} alt={'InDialog logo'}/>
                                    </a>
                                }

                            </div>
                        </div>

                    </div>
                </Slide>
            </div>
        );
    }
}

export default InfoPage;
